import { TFunction } from 'i18next'
import * as Yup from 'yup'

export function translateRoute(routeName: string, t: TFunction) {
  return t ? t(`routes:${routeName.replace(/\./g, '>')}`) : routeName
}

export function validationMessage(type: string, t: TFunction): string {
  return (({ path }: Partial<Yup.TestMessageParams>) =>
    t(`validation.${type}`, {
      field: path ? t(`field.${path}.label`) : undefined,
    })) as any
}

export function localizeYup(t: TFunction) {
  Yup.setLocale({
    mixed: { required: validationMessage('required', t) },
  })
}
